import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=cf09413a&"
import script from "./shopInfo.vue?vue&type=script&lang=js&"
export * from "./shopInfo.vue?vue&type=script&lang=js&"
import style0 from "./shopInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports